import { when } from '@execonline-inc/maybe-adapter';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import ClickableTooltip from '../../../../../ClickableTooltip';
import { ProductLicenseOverview } from '../../../Types';
import { T } from '../../../../../../Translations';

interface Props {
  license: ProductLicenseOverview;
}

function OverallocatedAlert({ license }: Props) {
  return when(license.allocatedCount > license.activatableCount, true)
    .map(() => (
      <ClickableTooltip
        tooltipId={`overallocated-licence-${license.id}`}
        tooltipIcon={<ExclamationCircleIcon className="w-5 stroke-red-600" />}
      >
        <T
          kind="Licenses are Over Allocated; there are..."
          allocatedCount={license.allocatedCount}
          count={license.activatableCount}
        />
      </ClickableTooltip>
    ))
    .getOrElse(emptyFragment);
}

export default observer(OverallocatedAlert);
